import httpService from "./httpService";

export default {
  getListDeptTlt(form) {
    return httpService.post("/deptTlt/getListDeptTlt", form);
  }
}



// WEBPACK FOOTER //
// ./src/services/departmentTltService.js